import {GET_WALLET_BALANCE,GET_WALLET_BALANCE_SUCCESS,GET_WALLET_BALANCE_ERROR,GET_WALLET_BALANCE_RESET} from '../actionTypes';


export const walletData = (getBalancePayload) => {
    return ({
        type: GET_WALLET_BALANCE,
        payload: {getBalancePayload},
    })
}
  
  export const walletDataSuccess = (data) => ({
    type: GET_WALLET_BALANCE_SUCCESS,
    payload: data,
  });
  
  export const walletDataReset = () => ({
    type: GET_WALLET_BALANCE_RESET,
  });
  
  export const walletDataError = (error) => ({
    type: GET_WALLET_BALANCE_ERROR,
    payload: error,
  });